import React from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { formatTokenCount } from "util/copilotContextUsage";
import styles from "./style.module.scss";

const ContextRing = ({ percent }) => {
  const radius = 7;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(100, Math.max(0, percent)) / 100) * circumference;

  return (
    <svg width="16" height="16" viewBox="0 0 18 18" className={styles.contextUsageRing} aria-hidden>
      <circle
        cx="9"
        cy="9"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.22"
        strokeWidth="2"
      />
      <circle
        cx="9"
        cy="9"
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform="rotate(-90 9 9)"
      />
    </svg>
  );
};

const ContextUsageIndicator = ({ usage }) => {
  const { t } = useTranslation();
  const percent = usage?.percent ?? 0;
  const usedLabel = formatTokenCount(usage?.usedTokens ?? 0);
  const maxLabel = formatTokenCount(usage?.maxTokens ?? 0);

  const toneClass =
    usage?.isFull || percent >= 95
      ? styles.contextUsageFull
      : usage?.isNearLimit || percent >= 85
        ? styles.contextUsageWarn
        : "";

  const tooltipTitle = (
    <div className={styles.contextUsageTooltip}>
      <div>{t("cx_gpt.context_usage_title", { percent })}</div>
      <div className={styles.contextUsageTooltipSub}>
        {t("cx_gpt.context_usage_detail", { used: usedLabel, max: maxLabel })}
      </div>
      {usage?.isNearLimit ? (
        <div className={styles.contextUsageTooltipHint}>
          {usage.isFull
            ? t("cx_gpt.context_usage_full")
            : t("cx_gpt.context_usage_near_limit")}
        </div>
      ) : null}
    </div>
  );

  return (
    <Tooltip title={tooltipTitle} placement="topRight">
      <button
        type="button"
        className={`${styles.contextUsage} ${toneClass}`.trim()}
        aria-label={t("cx_gpt.context_usage_title", { percent })}
      >
        <ContextRing percent={percent} />
        <span className={styles.contextUsagePercent}>{percent}%</span>
      </button>
    </Tooltip>
  );
};

export default ContextUsageIndicator;
